import classNames from 'classnames'
import { useEffect, useState } from 'react'

import { naverInAppRegex } from '../utils/regexPatterns'

interface CoverProps {
  isOpen: boolean
  className?: React.ComponentProps<'div'>['className'] | null
  children?: React.ReactNode
  zIndex?: React.CSSProperties['zIndex']
  id?: React.ComponentProps<'div'>['id']
  position?: React.CSSProperties['position']
  style?: boolean
}

const Cover = ({
  isOpen,
  className = '',
  position = 'absolute',
  children,
  zIndex = 'z-300',
  id,
  style = false
}: CoverProps) => {
  const [isNotNaverInApp, setIsNotNaverInApp] = useState(false)

  useEffect(() => {
    if (window === undefined) return
    const useragent = window && window.navigator.userAgent
    setIsNotNaverInApp(useragent.search(naverInAppRegex) === -1)
  }, [])

  return isOpen ? (
    <div
      id={id}
      className={classNames(`${position} bg-010 ${className} ${zIndex}`)}
      style={{ width: '100%', height: style ? '' : isNotNaverInApp ? '100dvh' : '100vh' }}
    >
      {children}
    </div>
  ) : (
    <></>
  )
}

export default Cover
